import React from 'react'
import GalleryEditPageComponent from './GalleryEditPageComponent'

const GalleryEditPage = () => {
  return (
    <div>
      <GalleryEditPageComponent/>
    </div>
  )
}

export default GalleryEditPage
